import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/provide/common.service';

@Component({
    selector: 'wishlist-card',
    templateUrl: './wishlist-card.component.html',
    styleUrls: ['./wishlist-card.component.scss'],
    standalone: false
})
export class WishlistCardComponent implements OnInit {
  @Input() data : any
  @Output() on_Click = new EventEmitter
  @Output() on_Click_Cat = new EventEmitter
  isLoaded: boolean;
  theme = {
    width: '100%',
    height: '280px',
    position: 'relative'
  };

  constructor(private commonService:CommonService) { }

  ngOnInit(): void {
  }
  navigateToViewProduct(e){
    this.on_Click.emit(e)
  }
  // navigateTocategory(e,data){
  //   this.on_Click_Cat.emit({
  //     e:e,data:data
  //   })
  // }
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  onImageLoad(){
    this.isLoaded = true
  }
}
